import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpClient} from '@angular/common/http';
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Order } from "../entities/order";
import { HttpService } from "./http-service";
import { InitProvider } from "./init-provider";
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import { DomSanitizer } from "@angular/platform-browser";
import "@angular/localize/init";
declare var $: any;

@Injectable({
  providedIn: "root",
})
export class RelatorioService extends HttpService {
  public pedido: Order;

  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object,
    public initProvider: InitProvider,
    private _sanitizer: DomSanitizer
  ) {
    super(http, router, toastService, platformId);
  }
  getRelatorios(data, callback, callbackError) {
    this.get(`relatorio/vendasPorPeriodo?data_inicial=${data.dataInicial}&data_final=${data.dataFinal}`, callback , callbackError);
  }
    getBoletoPdf(itens, callback, callbackErro) {
    this.postPdf(`print/boleto`, itens, callback, callbackErro);
  }
  
    getDanfePdf(itens, callback, callbackErro) {
    this.postXml(`print/danfe`, itens, callback, callbackErro);
  }

}


